import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-section"
}
const _hoisted_2 = { class: "admin-label" }
const _hoisted_3 = {
  key: 1,
  class: "supervisor-section"
}
const _hoisted_4 = { class: "supervisor-label" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import type { NavItem } from '@/config/navigation';
import { ltcsAdminEnterApi } from '@/services/api';

interface Props {
  modelValue: boolean;
  permanent?: boolean;
  collapsed?: boolean;
  menuItems: NavItem[];
  adminItems?: NavItem[];
  supervisorItems?: NavItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminNavi',
  props: {
    modelValue: { type: Boolean },
    permanent: { type: Boolean },
    collapsed: { type: Boolean },
    menuItems: {},
    adminItems: {},
    supervisorItems: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const route = useRoute();

const collapsed = computed(() => !!props.collapsed);
const drawerWidth = computed(() => {
  if (!props.permanent) return 280;
  return collapsed.value ? 72 : 248;
});
const adminList = computed(() => props.adminItems ?? []);
const supervisorList = computed(() => props.supervisorItems ?? []);

const closeIfOverlay = () => {
  if (!props.permanent) drawerProxy.value = false;
};

const openExternal = async (item: NavItem) => {
  closeIfOverlay();
  if (item.external !== 'ltcs-admin') return;
  const popup = window.open('about:blank', '_blank');
  if (!popup) {
    window.alert('새 창을 열 수 없습니다. 브라우저에서 팝업을 허용해 주세요.');
    return;
  }
  popup.document.body.textContent = '함우리몰관리를 여는 중입니다.';
  try {
    const res = await ltcsAdminEnterApi.openUrl();
    const data = res.data?.data || {};
    const action = String(data.action || '');
    const userId = String(data.userId || '');
    const password = String(data.password || '');
    if (!action || !userId || !password) throw new Error('empty');
    const doc = popup.document;
    doc.body.textContent = '';
    const form = doc.createElement('form');
    form.method = 'POST';
    form.action = action;
    const add = (name: string, value: string) => {
      const input = doc.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };
    add('userId', userId);
    add('password', password);
    add('rememberMe', data.rememberMe ? 'true' : 'false');
    doc.body.appendChild(form);
    form.submit();
  } catch (error: any) {
    popup.close();
    window.alert(error?.response?.data?.message || '함우리몰관리를 열지 못했습니다.');
  }
};

const drawerProxy = computed({
  get: () => props.modelValue,
  set: (v: boolean) => emit('update:modelValue', v)
});

// 현재 경로에 해당하는 메뉴 그룹을 자동으로 열기
const openedGroups = computed(() => {
  const currentPath = route.path;
  const opened: string[] = [];
  
  for (const item of [...props.menuItems, ...adminList.value, ...supervisorList.value]) {
    if (item.children) {
      const hasActiveChild = item.children.some(child => child.to === currentPath);
      if (hasActiveChild) {
        opened.push(item.title);
      }
    }
  }
  
  return opened;
});

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: drawerProxy.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawerProxy).value = $event)),
    class: _normalizeClass(["caion-nav-drawer admin-nav-drawer", { 'is-collapsed': collapsed.value }]),
    permanent: __props.permanent,
    temporary: !__props.permanent,
    width: drawerWidth.value,
    elevation: "0"
  }, {
    append: _withCtx(() => [...(_cache[5] || (_cache[5] = [
      _createElementVNode("div", { class: "drawer-footer" }, [
        _createElementVNode("span", { class: "footer-logo" }, "CAION"),
        _createElementVNode("span", { class: "footer-sub" }, "관리자 시스템")
      ], -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        nav: "",
        density: "comfortable",
        class: "menu-list",
        opened: openedGroups.value
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.title
            }, [
              (!item.children)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 0,
                    to: item.to,
                    "prepend-icon": item.icon,
                    title: collapsed.value ? undefined : item.title,
                    class: "menu-item",
                    rounded: "0",
                    onClick: closeIfOverlay
                  }, {
                    default: _withCtx(() => [
                      (collapsed.value)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            activator: "parent",
                            location: "end"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "prepend-icon", "title"]))
                : (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 1,
                    value: item.title
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                        "prepend-icon": item.icon,
                        title: item.title,
                        class: "menu-item",
                        rounded: "0"
                      }), null, 16, ["prepend-icon", "title"])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: child.title,
                          to: child.to,
                          "prepend-icon": child.icon,
                          title: child.title,
                          class: "menu-item sub-item",
                          rounded: "0",
                          onClick: closeIfOverlay
                        }, null, 8, ["to", "prepend-icon", "title"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["value"]))
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["opened"]),
      (adminList.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-shield-account-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "관리자 전용", -1))
            ]),
            _createVNode(_component_v_list, {
              nav: "",
              density: "comfortable",
              class: "menu-list admin-menu-list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adminList.value, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.title
                  }, [
                    (!item.children && item.external)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          "prepend-icon": item.icon,
                          title: collapsed.value ? undefined : item.title,
                          class: "menu-item menu-item--external",
                          rounded: "0",
                          onClick: ($event: any) => (openExternal(item))
                        }, {
                          default: _withCtx(() => [
                            (collapsed.value)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  activator: "parent",
                                  location: "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.title), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["prepend-icon", "title", "onClick"]))
                      : (!item.children)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            to: item.to,
                            "prepend-icon": item.icon,
                            title: collapsed.value ? undefined : item.title,
                            class: "menu-item",
                            rounded: "0",
                            onClick: closeIfOverlay
                          }, {
                            default: _withCtx(() => [
                              (collapsed.value)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    activator: "parent",
                                    location: "end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["to", "prepend-icon", "title"]))
                        : (_openBlock(), _createBlock(_component_v_list_group, {
                            key: 2,
                            value: item.title
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                                "prepend-icon": item.icon,
                                title: item.title,
                                class: "menu-item",
                                rounded: "0"
                              }), null, 16, ["prepend-icon", "title"])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: child.title,
                                  to: child.to,
                                  "prepend-icon": child.icon,
                                  title: child.title,
                                  class: "menu-item sub-item",
                                  rounded: "0",
                                  onClick: closeIfOverlay
                                }, null, 8, ["to", "prepend-icon", "title"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (supervisorList.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-shield-crown-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "슈퍼바이저 전용", -1))
            ]),
            _createVNode(_component_v_list, {
              nav: "",
              density: "comfortable",
              class: "menu-list supervisor-menu-list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supervisorList.value, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.title
                  }, [
                    (!item.children)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          to: item.to,
                          "prepend-icon": item.icon,
                          title: collapsed.value ? undefined : item.title,
                          class: "menu-item",
                          rounded: "0",
                          onClick: closeIfOverlay
                        }, {
                          default: _withCtx(() => [
                            (collapsed.value)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  activator: "parent",
                                  location: "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.title), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to", "prepend-icon", "title"]))
                      : (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 1,
                          value: item.title
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                              "prepend-icon": item.icon,
                              title: item.title,
                              class: "menu-item",
                              rounded: "0"
                            }), null, 16, ["prepend-icon", "title"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: child.title,
                                to: child.to,
                                "prepend-icon": child.icon,
                                title: child.title,
                                class: "menu-item sub-item",
                                rounded: "0",
                                onClick: closeIfOverlay
                              }, null, 8, ["to", "prepend-icon", "title"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "class", "permanent", "temporary", "width"]))
}
}

})